import { render } from "./ModelApp.vue?vue&type=template&id=66cf3fff&scoped=true"
import script from "./ModelApp.vue?vue&type=script&lang=js"
export * from "./ModelApp.vue?vue&type=script&lang=js"

import "./ModelApp.vue?vue&type=style&index=0&id=66cf3fff&lang=scss&scoped=true"

import exportComponent from "/home/forge/olyo.io/app-src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66cf3fff"]])

export default __exports__